export default "/_next/static/images/brian-yee-0d80f05520b3deb9ccc1bdc07f5c8a03.png";